import type { INextTriggerInfo } from '@/interfaces'

class NextTriggerInfo implements INextTriggerInfo {
  remainingOdometerReading?: number
  remainingMachineHours?: number
  nextTimeBasedTrigger?: string
  remainingTimespan?: string
  remainingTimeText?: string

  constructor(nextTriggerInfo?: any) {
    this.remainingOdometerReading = nextTriggerInfo?.remainingOdometerReading
    this.remainingMachineHours = nextTriggerInfo?.remainingMachineHours
    this.nextTimeBasedTrigger = nextTriggerInfo?.nextTimeBasedTrigger
    this.remainingTimespan = nextTriggerInfo?.remainingTimespan
    this.remainingTimeText = nextTriggerInfo?.remainingTimeText
  }
}

export default NextTriggerInfo
